import {
  ACTION_URGENCIES,
  cabinetSchema,
  type ActionUrgency,
  type OutstandingAction,
} from '@mfos/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../lib/api-client';
import { workspaceKey, workspacePath } from '../workspace/workspace.api';

export const cabinetKey = (workspaceId: string) =>
  [...workspaceKey(workspaceId), 'cabinet'] as const;

export function useCabinet(workspaceId: string) {
  return useQuery({
    queryKey: cabinetKey(workspaceId),
    queryFn: ({ signal }) =>
      apiGet(workspacePath(workspaceId, 'me', 'cabinet'), { schema: cabinetSchema, signal }),
  });
}

const URGENCY_RANK: Readonly<Record<ActionUrgency, number>> = Object.fromEntries(
  ACTION_URGENCIES.map((urgency, index) => [urgency, index]),
) as Record<ActionUrgency, number>;

/** URGENT first, then SOON, then INFO; earlier due dates first within the same urgency. */
export function sortOutstandingActions(actions: readonly OutstandingAction[]): OutstandingAction[] {
  return [...actions].sort((a, b) => {
    const byUrgency = URGENCY_RANK[a.urgency] - URGENCY_RANK[b.urgency];
    if (byUrgency !== 0) {
      return byUrgency;
    }
    if (a.dueAt !== null && b.dueAt !== null) {
      return Date.parse(a.dueAt) - Date.parse(b.dueAt);
    }
    return a.dueAt === null ? (b.dueAt === null ? 0 : 1) : -1;
  });
}
